<template>
    <div class="restriction-benefit-payment">
        {{ $t('productDetail.benefitPaymentRestriction') }}
    </div>
</template>

<style scoped lang="scss">
.restriction-benefit-payment {
    font-size: 13px;
    padding: 5px 1em;
    border-radius: $rounded;
    border: 1px solid $color-green-light;
    text-align: center;
    background: $color-alert-light;
    color: $color-alert;
    margin-top: 5px;
    margin-bottom: 10px;
}
</style>
